import cortanaComposeStore from '../store/cortanaComposeStore';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('clearFlexPaneResults', function clearFlexPaneResults() {
    cortanaComposeStore.viewState.flexPaneResults = [];
});
